import { asIsoDate } from '../primitives/branded.js';
/**
 * Trading-day helpers.
 *
 * All calendar maths runs in UTC. Bars are calendar days, so using local time
 * would shift a bar into the neighbouring day depending on the server's timezone.
 */
/** Today's trading date in UTC. */
export const todayIso = (now = new Date()) => asIsoDate(now.toISOString().slice(0, 10));
/** Converts a `Date` to `YYYY-MM-DD` in UTC. */
export const toIsoDate = (date) => asIsoDate(date.toISOString().slice(0, 10));
/** Parses `YYYY-MM-DD` into a UTC midnight `Date`. */
export const fromIsoDate = (value) => new Date(`${value}T00:00:00.000Z`);
/** Shifts an ISO date by whole days. */
export const addDays = (value, days) => {
    const date = fromIsoDate(value);
    date.setUTCDate(date.getUTCDate() + days);
    return toIsoDate(date);
};
/** Whole days between two ISO dates, `to - from`. */
export const daysBetween = (from, to) => Math.round((fromIsoDate(to).getTime() - fromIsoDate(from).getTime()) / 86_400_000);
/** True for Saturday and Sunday; exchange holidays are not modelled. */
export const isWeekend = (value) => {
    const day = fromIsoDate(value).getUTCDay();
    return day === 0 || day === 6;
};
/** Seconds since the epoch at UTC midnight — the time format lightweight-charts uses. */
export const toChartTime = (value) => fromIsoDate(value).getTime() / 1000;
/** Inverse of `toChartTime`. */
export const fromChartTime = (seconds) => toIsoDate(new Date(seconds * 1000));
/**
 * Formatiert `YYYY-MM-DD` für die Anzeige, standardmäßig als `15.12.2026`.
 *
 * Die ISO-Form ist ein Speicherformat. Auf dem Schirm liest sie sich wie eine
 * Kennung, nicht wie ein Datum — und genau dort, wo eine Frist steht, muss sie
 * ohne Nachdenken erfassbar sein.
 *
 * Ohne `Date`-Umweg: `fromIsoDate` legt Mitternacht UTC fest, `toLocaleDateString`
 * läse das in der Zeitzone des Browsers zurück und zeigte westlich von Greenwich
 * den Vortag.
 */
export const formatIsoDate = (value, options = {}) => {
    const { year = true } = options;
    const [y, m, d] = value.split('-');
    return year ? `${d}.${m}.${y}` : `${d}.${m}.`;
};
//# sourceMappingURL=date.js.map